import { enums } from "@shared/constants";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import CurrencyFormat from "@ui-kit/data-display/CurrencyFormat/CurrencyFormat.web";
import CustomPriceSelection from "@ui-application/form/custom-price-selection/CustomPriceSelection/CustomPriceSelection.web";
import ParsedHtml from "@ui-kit/typography/ParsedHtml/ParsedHtml.web";
import { PWYCTicketTypeProps } from "./PWYCTicketType.props";

const BACKEND_DEFAULT_DESCRIPTION =
  "Enjoy the event at a price that works for you. Choose the amount you\u2019d like to contribute \u2014 every bit helps support our community! This price is per ticket.";

const PWYCTicketType = (props: PWYCTicketTypeProps) => {
  const {
    defaultPrice,
    currency = enums.CURRENCY_MAP.CAD.id,
    quantityButtonsComponent,
    onSetPrice,
    price,
    pwycConfig,
  } = props;

  const { t } = useTranslation("pwyc");

  const description =
    pwycConfig.description === BACKEND_DEFAULT_DESCRIPTION
      ? t("pwyc-default-description")
      : pwycConfig.description;

  return (
    <Flex direction="column" gap="md">
      <Flex justifyContent="space-between">
        <Text
          fontSize={{
            base: "sm",
            sm: "lg",
          }}
          fontWeight="bold"
        >
          <CurrencyFormat
            data-testid="pwyc-ticket-type-price"
            value={price ?? defaultPrice}
            displayType="text"
            currency={currency}
            includeSuffix
          />
        </Text>
        <Flex>{quantityButtonsComponent}</Flex>
      </Flex>

      <Flex
        p="md"
        border="1px solid"
        borderColor="gray.400"
        direction="column"
        borderRadius="sm"
        gap="md"
      >
        <Flex direction="column" gap="xs">
          <Text fontWeight="bold" fontSize="md" lineHeight="19px">
            {t("Pay what you can")}
          </Text>
          {description && (
            <Text color="gray.600" lineHeight="19px">
              <ParsedHtml
                htmlString={description}
                elementStyles={{ p: "margin-bottom: 8px;" }}
              />
            </Text>
          )}
        </Flex>

        <CustomPriceSelection
          defaultPrice={defaultPrice}
          currency={currency}
          options={pwycConfig.options}
          minPrice={pwycConfig?.min_price}
          price={price}
          onSetPrice={onSetPrice}
          isFreeAllowed={pwycConfig.is_free_allowed}
        />
      </Flex>
    </Flex>
  );
};

export default PWYCTicketType;
